"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenForResult = void 0;
var andThen_1 = require("./andThen");
function flatten(input) {
    return input;
}
/**
 * Converts from `Result<Result<T, E>, E>` to `Result<T, E>`
 */
function flattenForResult(input) {
    var result = (0, andThen_1.andThenForResult)(input, flatten);
    return result;
}
exports.flattenForResult = flattenForResult;
